<template>
  <div>
    <!-- Section headings are rendered server-side from the shared
         shared/_section_heading partial (identical markup/style to the other
         Activity panels) and injected here. -->
    <!-- Activity to Copy -->
    <div class="sidepanel__block">
      <div v-html="headings.activity_to_copy"></div>
      <fieldset>
        <select v-model="selected" class="select select--full">
          <option v-for="option in eventParts" :key="option.value" :value="option.value">
            {{ option.name }}
          </option>
        </select>
        <input v-model="selected" name="event_part[copy_from_id]" type="hidden">
      </fieldset>
    </div>

    <!-- General: Name + Activity Type (mirrors Create from Scratch) -->
    <div class="sidepanel__block">
      <div v-html="headings.general"></div>
      <fieldset>
        <label for="event_part_name">{{ labels.name_label }}</label>
        <input
          v-model="name"
          maxlength="50"
          size="50"
          type="text"
          name="event_part[name]"
          id="event_part_name"
          class="input input--full input-max-length">
        <div v-for="error in nameError" :key="error" class="error">{{ error }}</div>
      </fieldset>
      <fieldset class="js-activity-type">
        <label>{{ labels.activity_type_label }}</label>
        <template v-for="option in typeOptions">
          <input
            :key="`${option.value}-input`"
            type="radio"
            class="radio"
            name="event_part[activity_type]"
            :id="`copy_activity_type_${option.value}`"
            :value="option.value"
            v-model="type">
          <label :key="`${option.value}-label`" :for="`copy_activity_type_${option.value}`" class="voidclick">
            {{ option.label }}
          </label>
        </template>
      </fieldset>
    </div>

    <!-- Schedule: the exact Create-from-Scratch range control (Start/End/Duration/TZ) -->
    <div class="sidepanel__block">
      <div v-html="headings.schedule"></div>
      <datepicker-range-with-timezone
        :key="selected"
        :start-datetime="start"
        :start-timezone="timezone"
        start-datetime-field-name="event_part[start_date_time]"
        start-timezone-field-name="event_part[start_time_zone]"
        :end-datetime="end"
        :end-timezone="timezone"
        end-datetime-field-name="event_part[end_date_time]"
        end-timezone-field-name="event_part[end_time_zone]"
        :end-datetime-error="endErrorJson"
        required="true"
        show-duration="true"
        single-timezone="true"
        time-suggestions="true"/>
      <div v-for="error in startError" :key="error" class="error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['event-parts', 'fixed-initial-time', 'initial-name', 'initial-time',
          'initial-end', 'initial-timezone', 'initial-type', 'initial-selected',
          'start-error', 'name-error', 'labels', 'headings'],

  data() {
    return {
      selected: this.initialSelected ? parseInt(this.initialSelected, 10) : null,
      name: this.initialName,
      type: this.initialType,
      start: (this.fixedInitialTime || this.initialTime),
      end: this.initialEnd,
      timezone: this.initialTimezone,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.selected = this.selected || (this.eventParts[0] && this.eventParts[0].value) || null;
      this.updateFromSource();
    });
  },

  watch: {
    selected() {
      this.updateFromSource();
    },
  },

  computed: {
    selectedEventPart() {
      return this.eventParts.find((eventPart) => eventPart.value === this.selected);
    },

    typeOptions() {
      const t = this.labels.type || {};
      return [
        { value: 'schedule', label: t.schedule },
        { value: 'registration', label: t.registration },
        { value: 'lead', label: t.lead },
      ];
    },

    endErrorJson() {
      return JSON.stringify([]);
    },
  },

  methods: {
    // Copy the fields most organizers change from the selected source; everything
    // else is inherited server-side. Default the name, Activity Type, and the
    // Start/End/Time Zone schedule from the source (a changed picker re-keys the
    // schedule control so it re-initialises).
    updateFromSource() {
      if (!this.selected) {
        this.start = this.fixedInitialTime || moment();
        return;
      }
      const source = this.selectedEventPart;
      this.name = `${source.name} (Copy)`;
      this.type = source.activity_type;
      this.start = this.fixedInitialTime || source.start_date_time;
      this.end = source.end_date_time;
      this.timezone = source.timezone;
    },
  },
};
</script>
